/* NAVERO custom product-card gallery: AV風の「1枚ずつ＋opacityフェード＋分割ライン」。
   Horizon標準のスクロール式カルーセルの上にかぶせて、スライドを重ねopacityで切替える。
   - スライドは active のみ relative(=高さを決める)＋opacity1、他は absolute 重ね＋opacity0。
   - スワイプ（タッチ）で前後に1枚ずつ。
   - 独自の分割ラインドット（現在位置が濃色）。 */
(function () {
  var SWIPE_MIN = 28;

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.nvrGallery === '1') return;
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('slideshow-slide, .slideshow-slide')
    );
    if (slides.length < 2) return;

    gallery.dataset.nvrGallery = '1';
    gallery.classList.add('nvr-fade-gallery');

    var idx = 0;

    // 既存のHorizonドット/矢印は隠す（独自ドットを使う）
    gallery.querySelectorAll('slideshow-controls, slideshow-arrows').forEach(function (el) {
      el.style.display = 'none';
    });

    // 独自ドット生成
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'nvr-dots';
    dotsWrap.setAttribute('aria-hidden', 'true');
    var dots = slides.map(function (_, n) {
      var d = document.createElement('span');
      d.className = 'nvr-dot';
      d.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(n);
      });
      dotsWrap.appendChild(d);
      return d;
    });
    gallery.appendChild(dotsWrap);

    function show(i) {
      idx = (i % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('nvr-active', n === idx);
        s.removeAttribute('aria-hidden');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === idx);
      });
    }

    // スワイプ
    var x0 = null, y0 = null, moved = false;
    gallery.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; moved = false;
    }, { passive: true });
    gallery.addEventListener('touchmove', function (e) {
      if (x0 == null) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) moved = true;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > SWIPE_MIN) {
        show(idx + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    // デスクトップ（hover環境のみ）：
    //  1) ホバーで2枚目へクロスフェード（離れたら1枚目へ戻る）
    //  2) ホバー時のみ表示される‹›矢印で1枚ずつ送れる（クリックはリンク遷移を止める）
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      var userNav = false;
      var CHEV_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5 8 12l7 7"/></svg>';
      var CHEV_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
      var mkArrow = function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nvr-arrow nvr-arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? '前の画像' : '次の画像');
        b.innerHTML = dir === 'prev' ? CHEV_PREV : CHEV_NEXT;
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          userNav = true;
          show(idx + (dir === 'next' ? 1 : -1));
        });
        return b;
      };
      gallery.appendChild(mkArrow('prev'));
      gallery.appendChild(mkArrow('next'));
      gallery.addEventListener('mouseenter', function () {
        if (!userNav && slides.length > 1) show(1);
      });
      gallery.addEventListener('mouseleave', function () {
        userNav = false;
        show(0);
      });
    }

    show(0);
  }

  function initAll() {
    document.querySelectorAll('.card-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // 動的レンダリング対策（軽いガード付き）
  var obs = new MutationObserver(function () {
    /* 2026-07-07監査修正：rAFは非表示タブで停止し初期化が保留される→setTimeoutに変更 */
    clearTimeout(window.__nvrCardGalleryTimer);
    window.__nvrCardGalleryTimer = setTimeout(initAll, 50);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
